import { localStorageStore } from 'react-admin';

/**
 * Where the admin's own preferences live.
 *
 * react-admin defaults to a memory store, so choosing dark mode lasted until
 * the tab was closed. localStorage keeps it across sessions on this machine,
 * which is what "remember my choice" means to somebody who works from the same
 * desk every day.
 *
 * The version string is a reset switch: bumping it discards stored preferences
 * for everyone, which is the escape hatch if a saved value ever stops making
 * sense against a changed screen.
 */
export const themeStore = localStorageStore('1', 'cleantonery-admin');
